import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import * as CryptoJS from 'crypto-js';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { ClientAppLogin, EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { GlobalService } from '../../helper/Services/global.service';
import { SecureStorage } from '../../helper/Services/secure-storage';
import { StatusTrackerKeys } from '../../Models/configuration';
import { AppConfigService } from '../../Services/appConfig/app-config.service';
import { CultureLocaleService } from '../../Services/culture/culture-locale.service';

@Component({
  selector: 'app-reg-validation',
  templateUrl: './reg-validation.component.html',
  styleUrls: ['./reg-validation.component.css']
})
export class RegValidationComponent implements OnInit {
  registrationNumber: string;
  errormessage: string;
  licensePlateClass: string;
  logoUrlLink: string;
  cookieScriptCdn: string;

  constructor(private router: Router, private gService: GlobalService, private secureStorage: SecureStorage,
    private authService: AppConfigService, private cultureLocaleService: CultureLocaleService,
    private translate: TranslateService,
    private globalSetting: GlobalSetting
  ) {

    this.cookieScriptCdn = EnvSetting.Tracker_CookieScript_Key;
  }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.logoUrlLink = this.globalSetting.getGlobalLogoUrlLink();
    let autoCarPlate = this.secureStorage.getKeyData(StatusTrackerKeys.autoCarPlate);
    if (autoCarPlate) {
      this.registrationNumber = autoCarPlate.toLowerCase();
      this.secureStorage.removeKey(StatusTrackerKeys.autoCarPlate);
      this.authenticateUser();
    }
  }

  // tslint:disable-next-line:typedef
  async authenticateUser() {
    if (isNullOrUndefined(this.registrationNumber)) {
      this.errormessage = this.translate.instant("lblLiscencePlateError");
    } else {
      const userlpNumber = this.registrationNumber.toLowerCase().replace(/\s/g, "");
      const tinyUrl = this.secureStorage.getKeyData(StatusTrackerKeys.tinyUrl);
      const StatusTrackerAuthParam = {
        repairStatusTinyUrl: tinyUrl,
        lpNumber: userlpNumber
      }
      await this.authService.getUserAuthenticatedDetails(StatusTrackerAuthParam)
        .subscribe(async (res) => {
          if (!isNullOrUndefined(res?.token) && res?.token != "") {
            ClientAppLogin(res.token);
            this.gService.setAppInitialData(res.data);
            await this.cultureLocaleService.initialise();
            this.router.navigate(['/order-status']);
          } 
          else if(res.statusCode == 404){
            this.errormessage = this.translate.instant("lblTrackerLinkExpired");
          }
          else {
            this.router.navigate(['/error-page']);
          }
        },
          (_err) => {
            this.errormessage = this.translate.instant("lblLiscencePlateError");
          });
    }
  }

  decryptForApi(key, ciphertextB64) {
    let decryptkey = CryptoJS.enc.Utf8.parse(key);
    let iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);
    let decrypted = CryptoJS.AES.decrypt(ciphertextB64, decryptkey, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}

